import { render, staticRenderFns } from "./KioskNoSubscription.vue?vue&type=template&id=e954ff66"
import script from "./KioskNoSubscription.vue?vue&type=script&lang=js"
export * from "./KioskNoSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports